/**
 * 杯子数据模型
 * @author jzs0914@126.com
 */
import {
  ValidatorStatus,
  Module,
  Option,
  PasterCategory,
  PastersConnect,
  PasterOption,
  LineTextOption,
  RulePaster,
  RuleLineText,
  RuleBottomImage
} from '@/sunzi';


/** 产品类型 */
export enum MugType {
  MUG = 'MUG',
  VACUUM_CUP = 'VACUUM_CUP', // 保温杯
  PLASTIC_CUP = 'PLASTIC_CUP', // 塑料杯
  DIGITAL_IMAGE = 'DIGITAL_IMAGE',
  PILLOW = 'PILLOW',
  sPILLOW = 'sPILLOW',
  SOCK = 'SOCK',
  CANVAS = 'CANVAS',
  hCANVAS = 'hCANVAS',
  vCANVAS = 'vCANVAS',
  sCANVAS = 'sCANVAS',  // 方形油画
  WHITE_aCANVAS = 'WHITE_aCANVAS', // 白底油画a
  vBLANKET = 'vBLANKET',
  DISC = 'DISC',
  PUZZLE = 'PUZZLE',
  TAPESTRY = 'TAPESTRY', // 挂毯
  cTAPESTRY = 'cTAPESTRY', // 圣诞挂毯
  GREETING_CARD = 'GREETING_CARD', // 贺卡
  TSHIRT = 'TSHIRT', // 小人T恤
  ORNAMENT = 'ORNAMENT' // 挂饰
}

/**
 * 杯子操作模块
 * @id 模块ID
 * @name 模块名称
 * @description 模块描述
 * @pasters 模块关联的贴纸数据
 * @optionText 模块选项描述文案
 * @pastersConnect 贴纸关联关系集合
 * @rules 模块规格
 * @options 选项数据
 */
export interface MugModule extends Module {
  pasters: PasterCategory[];
  pastersConnect: PastersConnect[];
  rules: MugRules;
  bottomImage: MugBottomImage[];
  options: MugOption[];
  bottomDisabled: boolean;
}

export interface MugModuleState extends MugModule {
  optionId?: number;
  validator: {
    status: ValidatorStatus;
    message: React.ReactNode[];
  };
}

/**
 * 底图
 * @image 图片
 * @thumbnail 缩略图
 */
export interface MugBottomImage {
  id: number;
  image: string;
  thumbnail: string;
}

/**
 * 模块规则
 * @paster 贴纸规则
 * @lineText 直线刻字规则
 * @bottomImage 底图规则
 */
export interface MugRules {
  paster: RulePaster;
  lineText?: RuleLineText;
  bottomImage: RuleBottomImage;
}

/**
 * 选项数据
 * @value 选项文案
 * @increaseAmount 加价金额
 * @pasters 贴纸默认数据
 * @lineText 直线刻字默认数据
 */
export interface MugOption extends Option {
  pasters: PasterOption[];
  lineTexts: LineTextOption[];
}

export interface SynchroObjects {
  object: fabric.Object;
  dataURL: string;
}
